/**
 * Which inline player, if any, a support attachment can drive.
 *
 * Zoom voicemail and call-recording notifications reach the desk as ordinary inbound email with the
 * recording attached, so the kind is read off the attachment rather than from anything Zoom-specific.
 */
export type AttachmentMediaKind = 'image' | 'audio' | 'video' | 'file';

export interface AttachmentMediaSource {
	fileName?: string;
	mimeType?: string;
}

const IMAGE_FILE_NAME_PATTERN = /\.(avif|bmp|gif|jpe?g|png|svg|webp)$/i;
const AUDIO_FILE_NAME_PATTERN = /\.(aac|flac|m4a|mp3|oga|ogg|opus|wav|weba)$/i;
const VIDEO_FILE_NAME_PATTERN = /\.(m4v|mov|mp4|ogv|webm)$/i;

export function getAttachmentMediaKind(attachment: AttachmentMediaSource): AttachmentMediaKind {
	const mimeType = attachment.mimeType?.toLowerCase() ?? '';
	if (mimeType.startsWith('image/')) return 'image';
	if (mimeType.startsWith('audio/')) return 'audio';
	if (mimeType.startsWith('video/')) return 'video';

	// Voicemail relays routinely send application/octet-stream, leaving the extension as the only signal.
	const fileName = attachment.fileName ?? '';
	if (IMAGE_FILE_NAME_PATTERN.test(fileName)) return 'image';
	if (AUDIO_FILE_NAME_PATTERN.test(fileName)) return 'audio';
	if (VIDEO_FILE_NAME_PATTERN.test(fileName)) return 'video';
	return 'file';
}
